module.exports = __webpack_public_path__ + "img/smartscreen2.bf4aed26.png";